var MAXIMUM_REWARD_RECIPIENTS = 30;
export default MAXIMUM_REWARD_RECIPIENTS;
